<template>
  <div>
    <MenuBar />
    <Slider />

    <div id="firstSectionContainer" :style="{ marginTop: this.marginTop + 'px' }">
      <img alt="Bangkok Lotteries Logo" src="../assets/logo-bangkok-lotteries.png" class="mobileOnly" />

      <transition enter-active-class="animated fadeIn slow" appear>
        <div class="flex">
          <div class="adsSpace1 desktopOnly">
            <a href="https://www.discoverthailandco.com" target="_blank">Bangkok. Enjoy your moment.</a>
          </div>

          <div>
            <div class="desktopOnly">
              <span v-if="this.langChosen === 'gr'">ผล</span>
              <span v-else>Results</span>
            </div>

            <div class="dateTitle">
              <span v-if="this.langChosen === 'gr'">{{ this.dataHariIni.date | dateFormatterGreek }}</span>
              <span v-else>{{ this.dataHariIni.date | dateFormatterEnglish }}</span>
            </div>

            <div class="resultCounted">
              <span class="resultCountedNumbers">{{ this.dataHariIni.result }}</span>
            </div>

            <div class="latestResult">
              <div class="numberBall">{{ this.dataHariIni.bolaSatu }}</div>
              <div class="numberBall">{{ this.dataHariIni.bolaDua }}</div>
              <div class="numberBall">{{ this.dataHariIni.bolaTiga }}</div>
              <div class="numberBall">{{ this.dataHariIni.bolaEmpat }}</div>
              <div class="numberBall">{{ this.dataHariIni.bolaLima }}</div>
              <div class="numberBall">{{ this.dataHariIni.bolaEnam }}</div>
            </div>

            <div class="additionalNumberRow">
              <div class="numberBall">+{{ this.dataHariIni.additionalNumber }}</div>
            </div>
          </div>

          <div class="adsSpace2 desktopOnly">
            <a href="https://www.tourismthailand.org" target="_blank">Visit Thailand!</a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Slider from './Slider';
import MenuBar from './MenuBar';

export default {
  props: ['dataHariIni'],
  filters: {
    dateFormatterGreek(date) {
      const dateObj = new Date(date);

      let dateDay = '';
      switch (dateObj.getDay()) {
        case 0:
          dateDay = 'วันอาทิตย์';
          break;
        case 1:
          dateDay = 'วันจันทร์';
          break;
        case 2:
          dateDay = 'วันอังคาร';
          break;
        case 3:
          dateDay = 'วันพุธ';
          break;
        case 4:
          dateDay = 'วันพฤหัสบดี';
          break;
        case 5:
          dateDay = 'วันศุกร์';
          break;
        case 6:
          dateDay = 'วันเสาร์';
          break;
      }

      let dateMonth = '';
      switch (dateObj.getMonth()) {
        case 0:
          dateMonth = 'มกราคม';
          break;
        case 1:
          dateMonth = 'กุมภาพันธ์';
          break;
        case 2:
          dateMonth = 'มีนาคม';
          break;
        case 3:
          dateMonth = 'เมษายน';
          break;
        case 4:
          dateMonth = 'อาจ';
          break;
        case 5:
          dateMonth = 'มิถุนายน';
          break;
        case 6:
          dateMonth = 'กรกฎาคม';
          break;
        case 7:
          dateMonth = 'สิงหาคม';
          break;
        case 8:
          dateMonth = 'กันยายน';
          break;
        case 9:
          dateMonth = 'ตุลาคม';
          break;
        case 10:
          dateMonth = 'พฤศจิกายน';
          break;
        case 11:
          dateMonth = 'ธันวาคม';
          break;
      }

      return `${dateDay}, ${dateObj.getDate()} ${dateMonth} ${dateObj.getFullYear()}`;
    },
    dateFormatterEnglish(date) {
      const dateObj = new Date(date);

      let dateDay = '';
      switch (dateObj.getDay()) {
        case 0:
          dateDay = 'Sunday';
          break;
        case 1:
          dateDay = 'Monday';
          break;
        case 2:
          dateDay = 'Tuesday';
          break;
        case 3:
          dateDay = 'Wednesday';
          break;
        case 4:
          dateDay = 'Thursday';
          break;
        case 5:
          dateDay = 'Friday';
          break;
        case 6:
          dateDay = 'Saturday';
          break;
      }

      let dateMonth = '';
      switch (dateObj.getMonth()) {
        case 0:
          dateMonth = 'January';
          break;
        case 1:
          dateMonth = 'February';
          break;
        case 2:
          dateMonth = 'March';
          break;
        case 3:
          dateMonth = 'April';
          break;
        case 4:
          dateMonth = 'May';
          break;
        case 5:
          dateMonth = 'June';
          break;
        case 6:
          dateMonth = 'July';
          break;
        case 7:
          dateMonth = 'August';
          break;
        case 8:
          dateMonth = 'September';
          break;
        case 9:
          dateMonth = 'October';
          break;
        case 10:
          dateMonth = 'November';
          break;
        case 11:
          dateMonth = 'December';
          break;
      }

      return `${dateDay}, ${dateObj.getDate()} ${dateMonth} ${dateObj.getFullYear()}`;
    },
  },
  components: {
    Slider,
    MenuBar,
  },
  created() {
    this.scrollListener();
  },
  methods: {
    scrollListener() {
      window.addEventListener('scroll', e => {
        this.marginTop = e.target.scrollingElement.scrollTop / 20;
      });
    },
  },
  data() {
    return {
      marginTop: '',
    };
  },
};
</script>

<style>
#firstSectionContainer {
  text-align: center;
  padding: 4vh 0 4vh 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#firstSectionContainer::before {
  content: '';
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 75vh;
  z-index: -10;
  background: url('../assets/backgroundFirstSection.jpg') no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.dateTitle {
  font-weight: 600;
  font-size: 1.75em;
  color: var(--lightColor);
  padding: 2vmin;
}

.numberBall {
  border-radius: 50%;
  background-color: white;
  font-size: 125%;
  box-sizing: border-box;
  width: 14vw;
  height: 14vw;
  max-width: 50px;
  max-height: 50px;
  color: var(--lightColor);
  font-weight: 600;
  background-color: #20bf55;
  background-image: linear-gradient(315deg, #20bf55 0%, #01baef 74%);
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-shadow: -0.5px -0.5px 0.5px #e6d6bb, 0.5px 0.5px 0.5px #a38a5f;
}

.latestResult {
  padding: 5vw 5vw 2vw 5vw;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100vw;
  max-width: 355px;
  margin: auto;
}

.resultCounted {
  font-weight: 600;
  font-size: 1.25em;
  color: var(--yellowPrim-lighter-4);
}

.resultCountedNumbers {
  text-decoration: underline;
  font-size: 15vw;
  letter-spacing: 1vw;
}

.fade1Sec-enter,
.fade1Sec-leave-to {
  opacity: 0;
}

.fade1Sec-enter-active,
.fade1Sec-leave-active {
  transition: opacity 1.5s;
}

.additionalNumberRow .numberBall {
  color: var(--lightColor);
  text-shadow: -0.5px -0.5px 0.5px #baa9a6, 0.5px 0.5px 0.5px #684a45;
  background-color: #0cbaba;
  background-image: linear-gradient(315deg, #0cbaba 0%, #380036 74%);
}

.additionalNumberRow {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 5vw;
}

.desktopOnly {
  display: none;
}

@media screen and (min-width: 768px) {
  #firstSectionContainer {
    display: block;
    background-color: var(--bluePrim-lighter-8);
    width: 90vw;
    margin: auto;
    border-radius: 10px;
    position: relative;
    top: -8vh;
    margin-top: 0;
  }

  .mobileOnly {
    display: none;
  }

  #firstSectionContainer::before {
    height: 100vh;
  }

  .resultCountedNumbers {
    font-size: 8vw;
    letter-spacing: 0.5vw;
    color: var(--primary);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  }

  .resultCounted {
    padding-top: 1vh;
  }

  .latestResult {
    padding-top: 4vh;
    padding-bottom: 1.5vh;
  }

  .dateTitle {
    padding: 0;
    color: var(--darkColor);
  }

  .sliderItem.banner1 {
    background: url('../assets/banner-1.jpg');
    background-position: center;
    height: 70vh;
    width: 100vw;
  }

  .additionalNumberRow {
    margin-bottom: 2vh;
  }

  .desktopOnly {
    display: block;
    font-weight: bold;
    font-size: 2em;
    color: var(--darkColor);
  }

  .flex {
    display: flex;
    justify-content: space-between;
    padding: 0 2vw;
  }

  .adsSpace1,
  .adsSpace2 {
    background-color: black;
    width: 30%;
    box-sizing: border-box;
  }

  .adsSpace1,
  .adsSpace2 {
    background-color: rgba(0, 0, 0, 1);
    overflow: hidden;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-size: cover;
    background-repeat: no-repeat;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
  }

  .adsSpace1 a,
  .adsSpace2 a {
    color: var(--lightColor);
    text-shadow: 2px 2px 5px black;
    text-decoration: none;
  }

  .adsSpace1 a:hover,
  .adsSpace2 a:hover {
    text-decoration: underline;
  }

  .adsSpace1 {
    background-image: url('../assets/side-banner-1.jpg');
    background-position: center;
  }

  .adsSpace2 {
    background-image: url('../assets/side-banner-2.jpg');
    background-position: bottom;
  }
}
</style>
